import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';

async function boot() {
  if (import.meta.env.MODE === 'mock') {
    const { startMockWorker } = await import('./mocks/browser');
    await startMockWorker();
  }
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void boot();
